export const hardRedirectTo = (targetUrl) => {
  if (typeof window === "undefined" || !window.location || !targetUrl) return false;

  window.location.assign(targetUrl);
  return true;
};
